// Shared layout/motion constants for the account-selector nodes. Kept in one
// place so the bank-account and counterparty selectors stay pixel-identical.

export const POPOVER_CONTENT_CLASS = 'w-[var(--radix-popover-trigger-width)] min-w-72 p-0';

// The trigger and the popover's search input are both h-9 (36px). Pulling the
// popover up by exactly the trigger's height lands its search input on top of the
// trigger, so the dropdown appears to morph into the search box (with the results
// hanging out below it) instead of dropping a second shadowed surface beneath it.
export const TRIGGER_HEIGHT_PX = 36;

// These dropdowns open directly on top of the trigger, so the popover's default
// scale-in (which grows from the top-left corner) would briefly render a narrower
// box and the width would visibly change mid-animation. Override to a pure opacity
// fade so the surface stays the full field width the entire time.
export const FADE_ONLY_MOTION = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
} as const;

// The card and dropdown overlap in one grid cell so the cell height is the taller
// of the two: as the card collapses, the space morphs down to the dropdown's size
// (and stops there), while the dropdown simply fades in — no slide, no clipping.
export const OVERLAP_GRID = 'grid grid-cols-1';
export const OVERLAP_CELL = 'col-start-1 row-start-1';
